// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MjT-G","icon":"styles_icon__54dWI","showIcon":"styles_showIcon__O-0-0","active":"styles_active__xvriG"};